




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";
import _ from "lodash";

interface Request {
    assignedUsers: User[];
}

interface User {
    displayName: string;
}

@Component({ components: { SimpleText } })
export default class Assigned extends Vue {
    @Prop( { default: null }) public request !: Request;

    public static getNeededFields(): string[] {
        return [
            "request.assignedUsers.displayName",
            "request.children.assignedUsers.displayName",
        ];
    }

    public get assignedAt(): string {
        if (!this.request.assignedUsers) {
            return "";
        }

        return this.request.assignedUsers.map((item: User) => item.displayName).join(", ");
    }
}
